'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGlobals$0024 from "./presto.-Globals$.js";
import * as $j_presto$002etypes$0024$002dFeatures$0024 from "./presto.types$-Features$.js";
import * as $j_presto$002etypes$0024$002dPlan$002dCode$0024 from "./presto.types$-Plan-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SingleAppToken(created, expires, user) {
  this.Yy = null;
  this.Yz = null;
  this.fi = null;
  this.Yy = created;
  this.Yz = expires;
  this.fi = user;
}
export { $c_Lpresto_types$SingleAppToken as $c_Lpresto_types$SingleAppToken };
$p = $c_Lpresto_types$SingleAppToken.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SingleAppToken;
/** @constructor */
function $h_Lpresto_types$SingleAppToken() {
}
export { $h_Lpresto_types$SingleAppToken as $h_Lpresto_types$SingleAppToken };
$h_Lpresto_types$SingleAppToken.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$SingleAppToken)) {
    var x = this.Yy;
    var x$2 = x$0.Yy;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      var x$3 = this.Yz;
      var x$4 = x$0.Yz;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.fi;
      var x$6 = x$0.fi;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "SingleAppToken";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.Yy;
      break;
    }
    case 1: {
      return this.Yz;
      break;
    }
    case 2: {
      return this.fi;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.cJn = (function(code) {
  return this.fi.rS.xa.cK(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$9) => _$9.Dz))).aE(code);
});
$p.cOq = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_IterableOnceOps__mkString__T__T__T__T(this.fi.rS.xa.cK(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$10) => _$10.Dz))).a3(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((t) => t))), "", ", ", "");
});
$p.adY = (function() {
  var this$1 = this.fi.ha.ja;
  var b = $j_presto$002e$002dGlobals$0024.$m_Lpresto_Globals$().mX;
  return ((this$1.e === b.e) && (this$1.f === b.f));
});
$p.cqW = (function() {
  return this.fi.rS.tP.cK(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$11) => _$11.KL)));
});
$p.a1U = (function() {
  return this.fi.rS.tP.eo(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((p) => $j_presto$002etypes$0024$002dPlan$002dCode$0024.$m_Lpresto_types$PlanCode$().c8h.aE(p.DA))));
});
$p.adX = (function(code) {
  return ((this.a1U().U() === 1) && this.a1U().gY(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$14) => (_$14.DA === code)))));
});
$p.ST = (function(code) {
  return ((code === $j_presto$002etypes$0024$002dFeatures$0024.$m_Lpresto_types$Features$().E4) ? (this.cqW().gY(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$15) => (_$15.Dy === code)))) && this.ST($j_presto$002etypes$0024$002dFeatures$0024.$m_Lpresto_types$Features$().lH)) : (this.a1U().k() || this.cqW().gY(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$16) => (_$16.Dy === code))))));
});
function $isArrayOf_Lpresto_types$SingleAppToken(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kd)));
}
export { $isArrayOf_Lpresto_types$SingleAppToken as $isArrayOf_Lpresto_types$SingleAppToken };
var $d_Lpresto_types$SingleAppToken = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SingleAppToken, "presto.types$SingleAppToken", ({
  kd: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$SingleAppToken as $d_Lpresto_types$SingleAppToken };
//# sourceMappingURL=presto.types$-Single-App-Token.js.map
